export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre décision"])},
        "agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent"])},
        "decision": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuser"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compléments"])}
        }
      },
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your decision"])},
        "agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent"])},
        "decision": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuse"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More info"])}
        }
      }
    }
  })
}
